module.exports = __webpack_public_path__ + "fonts/OpenSans-BoldItalic.183f1aa2.woff2";